__turbopack_context__.v({
  "className": "ibm_plex_mono_e0364159-module__eH8-sq__className",
  "variable": "ibm_plex_mono_e0364159-module__eH8-sq__variable",
});
